"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const screenConstants_1 = require("../../constants/screenConstants");
const homeLoan_1 = __importDefault(require("./homeLoan"));
const store_1 = require("../../store");
const homeApplication_1 = __importDefault(require("./homeApplication"));
const homeWarningCards_1 = __importDefault(require("../../components/messageCards/homeWarningCards"));
const navContainer_1 = __importDefault(require("../../components/navContainer/navContainer"));
const useGetUpdates_1 = __importDefault(require("../../hooks/useGetUpdates"));
const network_1 = require("../../utils/network");
const userGreetingMessage_1 = __importDefault(require("../../components/userGreetingMessage/userGreetingMessage"));
const Home = () => {
    (0, useGetUpdates_1.default)();
    const { ongoingLoanApplication, activeLoan, userData, npsSurvey, warnings, firstName } = (0, store_1.useAppSelector)((state) => {
        return {
            ongoingLoanApplication: state.home.ongoing_application,
            activeLoan: state.home.active_loan,
            userData: state.home.user_data,
            npsSurvey: state.home.nps_survey,
            warnings: state.home.warnings,
            firstName: state.home.user_data
                ? state.home.user_data.personal_information.first_name
                : state.auth.first_name,
        };
    });
    let content;
    let profilePhoto = {};
    let header;
    if (userData) {
        if (activeLoan && ongoingLoanApplication !== undefined) {
            content = react_1.default.createElement(homeLoan_1.default, { activeLoan: activeLoan });
        }
        else if (!ongoingLoanApplication) {
            content = react_1.default.createElement(homeApplication_1.default, null);
        }
        else {
            content = react_1.default.createElement(react_native_1.View, null);
        }
        if (userData.personal_information && userData.personal_information.profile_photo) {
            profilePhoto = userData.personal_information.profile_photo;
            if (process.env.NODE_ENV !== 'production' && profilePhoto) {
                profilePhoto = { uri: `${network_1.BASE_URL}${profilePhoto.uri}` };
            }
        }
        header = react_1.default.createElement(userGreetingMessage_1.default, { firstName: firstName, profilePhoto: profilePhoto });
    }
    return (react_1.default.createElement(navContainer_1.default, { isHomeContainer: true, header: header, footer: screenConstants_1.HOME_SCREEN, isLoading: false },
        react_1.default.createElement(homeWarningCards_1.default, { npsSurvey: npsSurvey, activeLoan: activeLoan, ongoingLoanApplication: ongoingLoanApplication, submittedRating: userData ? !!userData.user_submitted_rating : true, warnings: warnings }, content)));
};
exports.default = Home;
